<template>
  <div id="wechat_test_outer" class="container">
    <div id="wx_qr_div"></div>
  </div>
</template>

<script>
  import WeixinConfig from '../js/weixin.config';
export default {
  name: "TestWechatLogin",
  data () {
    return {
    }
  },
  mounted() {

    let query = this.$route.query;
    let state = query.state;
    let code = query.code;
    if (state == undefined && code == undefined ) {
      this.createQrCodeImage();

      return;
    }

    console.log(query);

    if (code == undefined) {
      this.createQrCodeImage();
      this.$toast('用户取消登录！');
    } else  {
      let _this = this;
      setTimeout(function () {
        let newLocation = _this.$router.resolve({
          name: 'weixinLoginBind',
          query: {
            code: code
          }
        });
        window.location.href = newLocation.href;
      }, 500);
    }
  },
  methods: {
    createQrCodeImage() {

      let redirectUri = encodeURI(window.location.href);
      console.log(redirectUri);

      let obj = new WxLogin({
        self_redirect: false,
        id: "wx_qr_div",
        appid: WeixinConfig.appId,
        scope: 'snsapi_login',
        redirect_uri: redirectUri,
        state: '1001',
        style: 'black',
        href: 'https://shslqxh.com/static/weixinlogin.css'
      });
    },
  }
}
</script>

<style scoped>
  #wechat_test_outer {

  }

  #wechat_test_outer > div {
    /*width: 150px;*/
    /*height: 150px;*/

  }
</style>



// WEBPACK FOOTER //
// src/pages/TestWechatLogin.vue